<table
  mat-table
  [dataSource]="dataSource"
  matSort
  [matSortActive]="defaultSort ?? ''"
  [matSortDirection]="defaultSortDirection ?? ''">
  @for (column of columnsDefinition; track column.name) {
    <ng-container [matColumnDef]="column.name">
      @if (column.sortable) {
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
          [id]="column.name"
          scope="col"
          class="title-table {{ column.headerStyle ?? '' }}">
          @if (column.headerIcon) {
            <mat-icon fontIcon="{{ column.headerIcon }}" class="material-icons-outlined"></mat-icon>
          } @else {
            {{ column.header | transloco }}
          }
        </th>
      } @else if (column.checkbox) {
        <th id="checkboxes" scope="col" mat-header-cell *matHeaderCellDef class="title-table">
          <mat-checkbox
            [checked]="allRowsChecked()"
            (change)="checkedAllRowsChanged($event.checked)">
          </mat-checkbox>
        </th>
        <td headers="checkboxes" class="content-table" mat-cell *matCellDef="let element">
          <mat-checkbox
            (change)="checkedRowChanged(element.id, $event.checked)"
            [checked]="rowChecked(element.id)"></mat-checkbox>
        </td>
      } @else {
        <th
          *matHeaderCellDef
          mat-header-cell
          [id]="column.name"
          scope="col"
          class="title-table {{ column.headerStyle }}">
          @if (column.headerIcon) {
            <mat-icon fontIcon="{{ column.headerIcon }}" class="material-icons-outlined"></mat-icon>
          } @else if (column.headerSvgIcon) {
            <mat-icon svgIcon="{{ column.headerSvgIcon }}"
                      ></mat-icon>
          } @else {
            {{ column.header | transloco }}
          }
        </th>
      }
      <ng-container *matCellDef="let element">
        <td [headers]="column.name" class="table-cell-content content-table" mat-cell>
          @if (column.isCellCustomized === true) {
            @if (customCellsTemplateRef) {
              <ng-container
                [ngTemplateOutlet]="customCellsTemplateRef"
                [ngTemplateOutletContext]="{
                  $implicit: element,
                  columnDefinition: column,
                }">
              </ng-container>
            }
          } @else {
            @switch (column.cellType) {
              @case ('innerHTML') {
                <div class="justify-space-between">
                  <div [innerHTML]="element[column.name]"></div>
                </div>
              }
              @case ('hours') {
                {{ element[column.name] | date: 'HH:mm' }}
              }
              @case ('date') {
                {{ element[column.name] | date: 'dd/MM/yyyy' }}
              }
              @case ('date-full') {
                {{ element[column.name] | date: "dd MMMM HH'h'mm" }}
              }
              @case ('date-time') {
                {{ element[column.name] | date: 'dd/MM/yyyy, HH:mm' }}
              }
              @default {
                {{ element[column.name] }}
              }
            }
          }
        </td>
      </ng-container>
    </ng-container>
  }

  @if (actionsTemplateRef) {
    <ng-container matColumnDef="actions">
      <th id="actions" scope="col" mat-header-cell *matHeaderCellDef class="action-table"></th>
      <td headers="actions" mat-cell *matCellDef="let element">
        <div class="actions justify-end">
          <ng-container
            [ngTemplateOutlet]="actionsTemplateRef"
            [ngTemplateOutletContext]="{ $implicit: element }">
          </ng-container>
        </div>
      </td>
    </ng-container>
  }

  <ng-container matColumnDef="footer">
    <th
      mat-footer-cell
      *matFooterCellDef
      [attr.colspan]="displayedColumns.length"
      class="table-footer">
      <div>
        <mat-paginator
          [pageSizeOptions]="[20, 50, 100, 200]"
          showFirstLastButtons
          [attr.aria-label]="'mealTray.tableOrders.selectPagePeriodicElements' | transloco">
        </mat-paginator>
        <ng-container *ngTemplateOutlet="footerTemplateRef"></ng-container>
      </div>
    </th>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr
    mat-row
    *matRowDef="let row; let i = index; columns: displayedColumns"
    class="tr-mat-row"
    [ngClass]="{
      focus: row?.id === selectedRow?.id,
      'clickable-row': isClickableRow,
    }"
    [id]="'row-' + i"
    (click)="emitRowData(row)"
    (keydown)="onKeyDownHandler($event, i)"></tr>

  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" [attr.colspan]="displayedColumns.length">
      @if (!(loading$ | async) || (loading$ | async) === false) {
        <logpn-no-result class="mg-sm"></logpn-no-result>
      } @else {
        <div class="mg-sm">&nbsp;</div>
      }
    </td>
  </tr>

  @if (displayPaginator) {
    <tr mat-footer-row *matFooterRowDef="['footer']; sticky: true"></tr>
  }
</table>
